<template>
    <p>
        apotheke am inselpark
        <br />
        Neuenfelder Str. 31
        <br />
        21109 Hamburg
    </p>
</template>
